import { useDispatch } from "react-redux";

import { ToastItem, toastSlice } from "../slices/toastSlice";

export const useDeleteToast = (): ((payload: ToastItem) => void) => {
  const dispatch = useDispatch();
  return (toast) => {
    const action = toastSlice.actions.delete(toast);
    dispatch(action);
  };
};
